import React, { ElementRef, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';
import HBClickable from '../HBClickable/HBClickable';
import { Plus16 } from '@honeybook/icons';
import HBText from '../HBText/HBText';

// TODO: why can't I use types from react-select???
interface InnerProps {
    innerRef: ElementRef<any>;
    innerProps: any;
}

interface Props {
    label: string;
    onClick: () => void;
    testIdName?: string;
}

const createOptionCustomMenu =
    ({ label, onClick, testIdName }: Props) =>
    ({ children, innerProps, innerRef }: PropsWithChildren<InnerProps>) => {
        return (
            <div ref={innerRef} {...innerProps}>
                {children}
                <Container
                    onClick={onClick}
                    onTouchEnd={onClick}
                    testIdName={testIdName || 'create-option-custom-menu'}
                >
                    <PlusIcon color={vars.colors.text.accent} />
                    <Label>{label}</Label>
                </Container>
            </div>
        );
    };

export default createOptionCustomMenu;

// -------------------------------- Styles -------------------------------- //
const Label = styled(HBText).attrs({
    type: 'emphasis14',
    color: 'text.accent'
})``;

const Container = styled(HBClickable)`
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: ${vars.colors.surface.item};

    &:hover {
        span {
            color: ${vars.colors.text.accentHover};
        }

        svg * {
            fill: ${vars.colors.text.accentHover};
        }
    }
`;

const PlusIcon = styled(Plus16)`
    margin-right: 10px;
`;
